export default "__VITE_ASSET__gxy6XlCY__"